import React from "react";

import { Combobox } from "@cayuse/shared-react.components.form.combobox";

import styles from "./styles.css";

const components = {
	StartIcon: (
		<svg aria-hidden="true" className="svg-inline--fa fa-magnifying-glass icon solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
			<path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
		</svg>
	),
	DropdownIcon: (
		<svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
			<path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
		</svg>
	),
	ClearIcon: (
		<svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
			<path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
		</svg>
	),
};

export const FlowableCombobox = props => {
	return (
		<Combobox
			cacheOptions={false}
			{...props}
			className={`${styles.wrapper} ${props.className ?? ""}`}
			inputClassName={`${styles.flowableCombobox} ${props.inputClassName ?? ""}`}
			components={components}
		/>
	);
};

FlowableCombobox.displayName = "FlowableCombobox";

FlowableCombobox.propTypes = Combobox.propTypes;
